module.exports = __webpack_public_path__ + "img/svg/background-messages-separator.cd540a73b4c9d2bf5bd618ffb6034513.svg";